// 设置面板（老板 2026-09-15 拍板：打开菜单，暂只配一项「背景音乐」开关）。
// 样式沿用 item-detail 弹层规格；面板文案不含阿拉伯数字（B1，away 态也可打开）。
import { useState } from 'react';
import { getMusicEnabled, setMusicEnabled } from '../audio/music';

interface SettingsPanelProps {
  onClose: () => void;
}

export function SettingsPanel({ onClose }: SettingsPanelProps) {
  const [musicOn, setMusicOn] = useState<boolean>(() => getMusicEnabled());

  const toggleMusic = () => {
    const next = !musicOn;
    setMusicOn(next);
    setMusicEnabled(next);
  };

  return (
    <div className="settings-overlay" onClick={onClose} role="presentation">
      <div
        className="settings-panel"
        role="dialog"
        aria-modal="true"
        aria-label="设置"
        onClick={(e) => e.stopPropagation()}
      >
        <button type="button" className="item-detail__close" onClick={onClose} aria-label="关闭设置">
          关闭
        </button>
        <p className="settings-panel__title">设置</p>
        <div className="settings-row">
          <span className="settings-row__label">背景音乐</span>
          <button
            type="button"
            role="switch"
            aria-checked={musicOn}
            aria-label="背景音乐开关"
            className={musicOn ? 'settings-switch is-on' : 'settings-switch'}
            onClick={toggleMusic}
          >
            {musicOn ? '开' : '关'}
          </button>
        </div>
        <button type="button" className="settings-panel__done" onClick={onClose}>
          好
        </button>
      </div>
    </div>
  );
}
